import { render, staticRenderFns } from "./contractList.vue?vue&type=template&id=2f4bbb9f&"
import script from "./contractList.vue?vue&type=script&lang=js&"
export * from "./contractList.vue?vue&type=script&lang=js&"
import style0 from "./contractList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports